<template>
  <div class="edit-org">
    <ep-title title="修改密码"></ep-title>
    <div class="ac-wrap" id="forget">
      <!-- 重置密码 -->
      <div class="ac-con">
        <div class="ac-con-lt">
          <div class="ac-general">当前密码</div>
          <div class="ac-general">新密码</div>
          <div class="ac-general">确认密码</div>
        </div>
        <div class="ac-con-ct">
          <div class="ac-general">
            <input type="password" name="" v-model="old_pwd" placeholder="请输入当前使用的密码" @focus="pwdStatuOld={type: '',msg: ''};confirmStatu={type: '',msg: ''};pwdState=true">
          </div>
          <div class="ac-general">
            <input type="password" name="" @keyup.down="changeFocus(1)" @keyup.up="changeFocus(1)" @keyup.enter="setPassword" v-model="pwd" @focus="pwdStatu={type: '',msg: ''};confirmStatu={type: '',msg: ''};pwdState=true" @blur="pwdState=false" placeholder="请输入新密码">
          </div>
          <div class="ac-general">
            <input type="password" @keyup.down="changeFocus(1)" @keyup.up="changeFocus(1)" @keyup.enter="setPassword" name="" v-model="confirm" placeholder="请再次输入新密码">
          </div>
          <div class="ac-general">
            <!--             <div class="ac-btn" @click="setPassword">提交</div> -->
            <el-button type="primary" @click="setPassword" class="ac-btn">提交</el-button>
            <el-button @click="close_bu" class="ac-btn">取消</el-button>
          </div>
        </div>
        <div class="ac-con-rt">
          <div class="ac-general">
            <p class="ac-con-msg" v-if="pwdStatuOld.type!=''">
              <ep-alert :type="pwdStatuOld.type">{{pwdStatuOld.msg}}</ep-alert>
            </p>
          </div>
          <div class="ac-general">
            <p class="message-tip" v-if="pwdShowTip">
              密码长度为8-20个字符，且至少包含1个大写字母，1个小写字母和1个数字
            </p>
            <p class="ac-con-msg" v-if="pwdStatu.type!=''">
              <ep-alert :type="pwdStatu.type">{{pwdStatu.msg}}</ep-alert>
            </p>
          </div>
          <div class="ac-general">
            <p class="ac-con-msg" v-if="confirmStatu.type!=''">
              <ep-alert :type="confirmStatu.type">{{confirmStatu.msg}}</ep-alert>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import account from '../../data/ucenter/account.js'
import captcha from '../../data/ucenter/captcha.js'

export default {
  data() {
    return {
      old_pwd: '',
      // 输入密码
      pwd: '',
      // 密码校验
      pwdUrl: ['../../../static/img/1.png', '../../../static/img/1.png', '../../../static/img/1.png',
        '../../../static/img/1.png'
      ],
      pwdShowTip: false,
      pwdStatuOld: false,
      // 校验框状态
      pwdState: false,

      // 密码状态
      pwdStatu: {
        type: '',
        msg: ''
      },
      // 再次输入密码
      confirm: '',
      // 再次输入状态
      confirmStatu: {
        type: '',
        msg: ''
      },
      statelist: {}
    }
  },

  mounted() {
    this.changeFocus(0)

  },
  created() {
    this.profile()
  },
  watch: {
    // 实时监听密码变动
    pwd() {
      this.formatPwd(this.pwd)
    }
  },
  methods: {
    // 获取用户信息
    profile() {
      (async () => {
        this.statelist = await account.get_profile()
        if (this.statelist) {
          // this.$message.success('');
        } else {
          // this.$message.error('');
        }
      })()
    },
    // 设置密码
    setPassword() {
      this.pwdState_old = false
      // 验证密码格式是否正确
      /* let pwdState_old = account.vertify_password(this.old_pwd)
       let changeOldPwdState = (type, msg) => {
        this.pwdStatuOld.type = type
        this.pwdStatuOld.msg = msg
      }
      if (pwdState_old.type != 2) {
        changeOldPwdState('error', pwdState_old.msg)
        return
      } else {
        changeOldPwdState('success', pwdState_old.msg)
      }*/

      this.pwdState = false
      // 验证密码格式是否正确
      let pwdState = account.vertify_password(this.pwd)
      let changePwdState = (type, msg) => {
        this.pwdStatu.type = type
        this.pwdStatu.msg = msg
      }
      if (pwdState.type != 2) {
        changePwdState('error', pwdState.msg)
        return
      } else {
        changePwdState('success', pwdState.msg)
      }
      // 验证密码是否输入一致
      let pwdAccord = account.vertify_accord(this.pwd, this.confirm)
      let changeConfirmStatu = (type, msg) => {
        this.confirmStatu.type = type
        this.confirmStatu.msg = msg
      }
      if (pwdAccord.type != 2) {
        changeConfirmStatu('error', pwdAccord.msg)
        return
      } else {
        changeConfirmStatu('success', pwdAccord.msg)
      }
      // 重置密码
      (async () => {
        let isSuccess = await account.changepasswd({
          oldPassword: this.old_pwd,
          newPassword: this.pwd
        })
        if (isSuccess.status) {
          this.$message.success('密码修改成功');
          this.pwdStatuOld.type = 'success'
          this.logout()
        } else {
          this.$message.error('密码修改失败，请重试');
          this.pwdStatuOld.msg = isSuccess.msg
          this.pwdStatuOld.type = 'error'
        }
      })()
    },
    logout() {
      (async () => {
        let islogout = await account.logout()
        if (islogout) {
          this.$router.push('/login')
        } else {
          this.$message.error('注销失败');
        }
      })()
    },
    // 切换焦点
    changeFocus(num) {
      let allInput = document.getElementById('forget').getElementsByClassName('ac-con')[0].querySelectorAll('input')
      if (num < allInput.length && num > -1) {
        allInput[num].focus()
      }
    },
    // 实时校验密码格式
    formatPwd(data) {
      let pwdState = account.vertify_password(data);
      this.pwdShowTip = pwdState.type!=2;
    },
    close_bu() {
      this.$router.push('/user')
    }
  }
}

</script>
<style lang="stylus" scoped>
.ac-wrap {
  margin-top: 20px;
  width: 100%;
  height: 100%;
  position: relative;
  .ac-con {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-flex;
    .ac-con-lt {
      width: 100px;
      height: 100%;
      margin-right: 30px;
      font-size: 16px;
      color: #666666;
      text-align: right;
    }
    .ac-con-ct {
      width: 340px;
      height: 100%;
      margin-right: 30px;
      text-align: left;
      .ac-btn {
        width: 100px;
        height: 35px;
        text-align: center;
        border-radius: 5px; // background: #2db7f5;
        transition: all .3s ease-in-out;
        cursor: pointer;
        a {
          text-decoration: none;
          color: #fff;
        }
      }
      .ac-verify {
        display: inline-block;
        height: 40px;
        width: 120px;
        border: 1px solid #DCDCDC;
        float: right;
      }
      .ac-send {
        text-align: center;
        color: #666;
        font-size: 14px;
        border-radius: 5px;
        cursor: pointer;
        &:hover {
          border: 1px solid #2ea9df;
          color: #2ea9df;
        }
      }
      .active {
        cursor: no-drop;
      }
    }
    .ac-con-rt {
      flex: 1;
      height: 100%;
      .ac-con-msg {
        display: block;
        height: 40px;
        width: 100%;
        line-height: 50px;
        text-align: left;
      }
      .message-tip{
        font-size: 14px;
        color: red;
      }
      .ac-check {
        height: 145px;
        width: 164px;
        background: url('../../../static/img/kuang.png') no-repeat center;
        box-sizing: border-box;
        padding: 10px;
        .ac-check-list {
          height: 30px;
          color: #666;
          font-size: 12px;
          text-align: left;
          text-indent: 10px;
          img {
            margin-right: 10px;
          }
        }
      }
    }
    .ac-general {
      width: 100%;
      height: 40px;
      margin-bottom: 30px;
      line-height: 40px;
    }
    input {
      width: 100%;
      height: 100%;
      border: 1px solid #c1c1c1;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 0 10px;
      &:focus {
        outline: none;
        box-shadow: 0 0 5px rgba(85, 190, 234, 1);
        border: 1px solid #55beec;
      }
    }
  }
}

</style>
</style>



// WEBPACK FOOTER //
// Modifypwd.vue?075ae4ad